import React from 'react';
import { Box, Typography } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const ComingSoon = ({ title }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100%', 
        minHeight: '60vh',
        color: 'text.secondary',
        textAlign: 'center',
        padding: 3
      }}
    >
      <ConstructionIcon sx={{ fontSize: 80, color: 'primary.main', mb: 2, opacity: 0.8 }} />
      <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" color="text.primary">
        Coming Soon
      </Typography>
     
    </Box>
  );
};

export default ComingSoon;
